import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../app/hooks';
import { ROUTE_BOOK_LOCATION } from '../util/constants';

/** "555 East 5th Avenue, Vancouver, BC V5T 1H8" from the booking's address. */
export function serviceAddressLine(address?: {
  street?: string | null;
  city?: string | null;
  provinceCode?: string | null;
  postalCode?: string | null;
} | null): string {
  if (!address) return '';
  const region = [address.provinceCode, address.postalCode]
    .filter(Boolean).join(' ');
  return [address.street, address.city, region]
    .map((part) => String(part || '').trim())
    .filter((part) => part && part !== 'undefined')
    .join(', ');
}

/**
 * Where the service happens, on the booking steps after the address step,
 * with a way back to change it (QA 2026-09-25 #27: the address never showed
 * again, so nobody could see that autocomplete had turned "555 5th Street"
 * into "555 East 5th Avenue", and with two tabs open only the tax rate told
 * them apart). Rendered by the steps only under a theme preset; styled by
 * `apr-service-address` in public/aperio/theme.css.
 */
export default function ServiceAddressSummary() {
  const { t } = useTranslation();
  const serviceAddress = useAppSelector(
    (state) => state.serviceLocation.serviceAddress,
  );
  const line = serviceAddressLine(serviceAddress);
  if (!line) return null;
  return (
    <div className="apr-service-address" data-testid="service-address">
      <span className="apr-service-address__label">
        {t('summary.serviceAddress')}
      </span>
      <span className="apr-service-address__value">{line}</span>
      <Link className="apr-service-address__change" to={ROUTE_BOOK_LOCATION}>
        {t('summary.change')}
      </Link>
    </div>
  );
}
